import { Instagram } from "lucide-react";
import { Reveal, Magnetic } from "./effects";

const IG_URL = "https://instagram.com/sheen.creates";

const tiles = [
  { src: "/thumbs/captions-1.jpg", alt: "Kinetic captions edit" },
  { src: "/thumbs/new-1.jpg", alt: "Beauty UGC styling" },
  { src: "/brand-img.webp", alt: "Product photography" },
  { src: "/thumbs/restaurant.jpg", alt: "Restaurant reel" },
  { src: "/thumbs/captions-2.jpg", alt: "Bold typography reel" },
  { src: "/thumbs/new-2.jpg", alt: "Food blogging reel" },
  { src: "/thumbs/new-4.jpg", alt: "Luxury product UGC" },
  { src: "/thumbs/talking-head.jpg", alt: "Talking head edit" },
];

export const InstagramStrip = () => (
  <section data-testid="instagram-strip-section" className="relative py-20 border-t border-white/5 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 mb-10 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
      <Reveal>
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-[#F5DE81] font-medium">
          <span className="h-px w-8 bg-[#D4AF37] inline-block" />
          Fresh from Instagram
        </span>
        <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight mt-4">
          Latest on <span className="text-gradient-blue">@sheen.creates</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Magnetic strength={0.25}>
          <a
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-2.5 rounded-full border border-[#D4AF37]/50 text-white text-xs font-semibold tracking-wide px-6 py-3 hover:bg-[#D4AF37]/15 hover:border-[#D4AF37] transition-all duration-300 shadow-[0_0_24px_rgba(212,175,55,0.15)]"
          >
            <Instagram size={15} /> Follow Along
          </a>
        </Magnetic>
      </Reveal>
    </div>

    <div className="marquee-mask overflow-hidden">
      <div className="animate-marquee flex w-max gap-4 pr-4" style={{ animationDuration: "46s" }}>
        {[...tiles, ...tiles].map((t, i) => (
          <a
            key={`${t.src}-${i}`}
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={i < tiles.length ? `instagram-tile-${i + 1}` : undefined}
            className="group relative block h-44 w-32 sm:h-56 sm:w-40 shrink-0 rounded-2xl overflow-hidden border border-white/10 hover:border-[#D4AF37]/60 transition-colors duration-500"
          >
            <img
              src={t.src}
              alt={t.alt}
              loading="lazy"
              className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
            <span className="absolute inset-0 bg-black/0 group-hover:bg-black/45 transition-colors duration-500 flex items-center justify-center">
              <Instagram size={22} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);
